import type { QualificationAnswers } from '@nexofacil/schemas';

// Persist the qualification answers to sessionStorage so the user doesn't lose
// progress if they accidentally close the tab during the same browsing session.
// Contact info (name, email, phone) is intentionally NOT persisted · it's
// sensitive and the user can re-type quickly.

const KEY = 'nexofacil-form-draft-v1';

type Draft = {
  step: number;
  answers: Partial<QualificationAnswers>;
};

export function saveFormDraft(draft: Draft): void {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(draft));
  } catch {
    // sessionStorage can throw in private mode · best-effort, ignore.
  }
}

export function loadFormDraft(): Draft | null {
  try {
    const v = sessionStorage.getItem(KEY);
    if (!v) return null;
    return JSON.parse(v) as Draft;
  } catch {
    return null;
  }
}

export function clearFormDraft(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // ignore
  }
}
